import React from "react";

const MapButton = ({ ...props }) => (
  <button
    className="grid place-items-center size-10 p-2 rounded-sm bg-white cursor-pointer shadow-sm text-primaryDark"
    {...props}
  />
);

export default MapButton;
